import { isDescriptionHidden, ControlProps } from '@jsonforms/core';
import merge from 'lodash/merge';
import { Form, Input } from 'antd';
import { useState } from 'react';

export const NativeControl: React.FC<ControlProps> = ({
  id,
  errors,
  label,
  schema,
  description,
  enabled,
  visible,
  required,
  path,
  handleChange,
  data,
  config,
  uischema,
}) => {
  const [onFocus, setOnFocus] = useState<boolean>(false);
  const isValid = errors.length === 0;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);
  const fieldType = schema.format;
  const showDescription = !isDescriptionHidden(
    visible,
    description,
    onFocus,
    appliedUiSchemaOptions.showUnfocusedDescription
  );

  const inputStyle = appliedUiSchemaOptions.trim ? {} : { width: '100%' };
  const helpContent = !isValid ? errors : (showDescription && description);

  return (
    <Form.Item
      hidden={!visible}
      required={required}
      label={label}
      hasFeedback={!isValid}
      status={isValid ? 'success' : 'error'}
      help={helpContent || null}
    >
      <Input
        id={id + '-input'}
        type={fieldType}
        disabled={!enabled}
        onFocus={() => setOnFocus(true)}
        style={inputStyle}
        value={data as string}
        onChange={ev =>
          handleChange(path, (ev.target as HTMLInputElement).value)
        }
      />
    </Form.Item>
  );
};
